import React, { useContext, useState } from "react";
import PropTypes from "prop-types";

import { Button, Responsive } from "semantic-ui-react";

import { useBooleanState } from "hooks";
import { useFeatures } from "components/FeatureFlag";
import Popper from "components/Popper";

import { SCREEN_TYPE } from "../../Container";
import { HubContext, ToasterContext } from "../../Provider";
import { useScreenManager } from "..";

export function CreateWorkflow({ onCreate, onCreateFromTemplate }) {
  const [loading, setLoading] = useState(false);
  const [isOpen, open, close] = useBooleanState();

  const { createWorkflow } = useContext(HubContext);
  const { fireError, fireSuccess } = useContext(ToasterContext);

  const allowTemplates = useFeatures("add-to-hub");
  const screen = useScreenManager();

  const newWorkflow = () => {
    setLoading(true);
    createWorkflow({
      name: "Untitled",
    })
      .then((resp) => {
        onCreate(resp);
        fireSuccess("Successfully created workflow.");
      })
      .catch((error) => {
        fireError("Failed to create workflow.", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleScreenPromotion = (withCallback = () => {}) => {
    if (screen.front() !== SCREEN_TYPE.WORKFLOW)
      screen.promote(SCREEN_TYPE.WORKFLOW);
    withCallback();
  };

  if (allowTemplates) {
    return (
      <Popper
        flowing
        position="top right"
        style={{ padding: "0" }}
        open={isOpen}
        onOpen={() => {
          handleScreenPromotion();
          open();
        }}
        onClose={() => {
          close();
        }}
        trigger={
          <div>
            <Responsive
              as={Button}
              basic
              icon="plus"
              id="filter-workflow-button"
              maxWidth={1350}
              style={{ marginRight: 0 }}
            />
            <Responsive
              as={Button}
              basic
              content="Create Workflow"
              icon="plus"
              id="filter-workflow-button"
              minWidth={1351}
              style={{ marginRight: 0, whiteSpace: "nowrap" }}
            />
          </div>
        }
      >
        <Button.Group basic vertical style={{ border: "none" }}>
          <Button
            content="New"
            style={{ textAlign: "left" }}
            loading={loading}
            onClick={() => {
              newWorkflow();
            }}
          />
          <Button
            content="From Template"
            style={{ textAlign: "left" }}
            onClick={() => {
              onCreateFromTemplate();
              close();
            }}
          />
        </Button.Group>
      </Popper>
    );
  }

  return (
    <div>
      <Responsive
        as={Button}
        basic
        icon="plus"
        id="filter-workflow-button"
        maxWidth={1350}
        loading={loading}
        onClick={() => {
          handleScreenPromotion(newWorkflow);
        }}
        style={{ marginRight: 0 }}
      />
      <Responsive
        as={Button}
        basic
        content="Create Workflow"
        icon="plus"
        loading={loading}
        id="filter-workflow-button"
        minWidth={1351}
        onClick={() => {
          handleScreenPromotion(newWorkflow);
        }}
        style={{ marginRight: 0, whiteSpace: "nowrap" }}
      />
    </div>
  );
}

CreateWorkflow.propTypes = {
  onCreate: PropTypes.func.isRequired,
  onCreateFromTemplate: PropTypes.func.isRequired,
};

export default CreateWorkflow;
